var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPC)?_c('DownloadAds'):_c('DownloadAdsMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }